// Module
var code = "<cs-get-started class=\"cs-flex-column-no-overflow\" cs-check-sample-data=\"false\"> <react-applications-grid class=\"cs-flex\"></react-applications-grid> <div data-ng-controller=\"ApplicationsCtrl\" ng-if=\"isFreemium()\"> <react-sliding-tutorial is-visible=\"tutorial.isVisible\" org-uuid=\"tutorial.orgUuid\" tutorial-key=\"tutorial.key\"></react-sliding-tutorial> </div> </cs-get-started>";
// Exports
var _module_exports =code;;
var path = '/views/applications.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;